import { connect } from 'react-redux';
import MetricsSelection from '../components/MetricsSelection';
import { getMetricsSelectionPage } from '../selectors';
import { changeMetricSelection } from '../actions';

const mapStateToProps = state => getMetricsSelectionPage(state);

const mapDispatchToProps = dispatch => {
    return {
        onChange: (id, value) => dispatch(changeMetricSelection(id, value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(MetricsSelection);
